.modifyControlRow {
    display: flex;
    gap: 20px;
    margin: 20px 0px;
    width: 100%;
    flex-direction: row-reverse;
}
.controlGroupListing {
    width: 70%;
}
.groupOutcomeContainer {
    width: 30%;
}
.groupOutcome {
    display: flex;
    justify-content: center;
    flex-direction: column;
    height: 100%;
}
.groupResultTextContainer {
    display: flex;
    flex-direction: row;
    align-items: center;

}
.tooltip {
    margin-left: 0.375rem;
    display: flex;
    align-items: center;
    justify-content: center;
}
.resultIconContainer, .iconContainer {
    display: flex;
    align-items: center;   
}
.resultIconContainer {
    padding: 0 0.375rem 0 0;
}
.iconContainer {
    justify-content: center;
    width: 1.5rem;
}
.controlGroupListingContent {
    display: flex;
    align-items: center;
    gap: 20px;
}
.contentContainer {
    display: flex;
    flex-direction: column;
    flex: 1;
}
.controlsContainer {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    justify-content: space-between;
}
.controlContainer {
    display: flex;
    align-items: center;
}

.controlContainer > div > a {
    max-width: 175px;
}
.controlContainer:nth-child(even) {
    min-width: 135px;
}
.dropdownButton {
    display: flex;
    flex-direction: row-reverse;
    flex-shrink: 0;
}
.showAllButton {
    margin: auto;
    margin-top: 15px;
    width: 70%;
}
@media only screen and (max-width: 1180px) {
    .controlGroupListingContent {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }
    .controlContainer {
        width: 100%;
    }
    .dropdownButton {
       display: block;
    }
    .showAllButton {
        margin: 15px 0px;
    }
}

